/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigNoContentResponse,
  BboBranchConfigUnauthorizedResponse,
  GetPouchCommonConfigResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get pouch common config
 * @summary Get pouch common config
 */
export const getPouchCommonConfig = (signal?: AbortSignal) => {
  return customInstance<GetPouchCommonConfigResponseResponse | BboBranchConfigNoContentResponse>({
    url: `/BboBranchConfigService/v1/pouch/common/config`,
    method: 'get',
    signal,
  });
};

export const getGetPouchCommonConfigQueryKey = () => {
  return [`/BboBranchConfigService/v1/pouch/common/config`] as const;
};

export const getGetPouchCommonConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchCommonConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchCommonConfig>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchCommonConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchCommonConfig>>> = ({ signal }) =>
    getPouchCommonConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchCommonConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchCommonConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPouchCommonConfig>>
>;
export type GetPouchCommonConfigQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get pouch common config
 */
export const useGetPouchCommonConfig = <
  TData = Awaited<ReturnType<typeof getPouchCommonConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchCommonConfig>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchCommonConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
